/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSwitchVertical = createReactComponent("switch-vertical", "IconSwitchVertical", [
  ["path", { d: "M3 8l4 -4l4 4", key: "svg-0" }],
  ["path", { d: "M7 4l0 9", key: "svg-1" }],
  ["path", { d: "M13 16l4 4l4 -4", key: "svg-2" }],
  ["path", { d: "M17 10l0 10", key: "svg-3" }]
]);

export { IconSwitchVertical as default };
//# sourceMappingURL=IconSwitchVertical.js.map
